import { render, staticRenderFns } from "./multiplePackages.vue?vue&type=template&id=0f6be528"
import script from "./multiplePackages.vue?vue&type=script&lang=js"
export * from "./multiplePackages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports